<div class="mobileTicket">
  <div class="laoding" *ngIf="isShowLoading">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>
  <div class="ticketHeader">
    <div class="ticketTitle">
      <div class="back mr10" (click)="back()">
        <div class="backInco"></div>
      </div>{{'ticket.ticketTitle' | translate}}
    </div>
    <button mat-raised-button color="primary" (click)="copyLink()" class="mr20" *ngIf="ticketStatusID != 0">{{'ticket.copyLink' | translate}}</button>
    <!-- Hidden: View Logs button -->
    <!-- <div class="logInfo cursor" (click)="showLogs()" *ngIf="ticketStatusID != ticketStatusEnum['create'] && isSupport">
        {{'ticket.gotologs' | translate}}
      </div> -->
  </div>
  <form class="mt40 pd30" [formGroup]="ticketForm">
    <nz-form-item *ngIf="ticketStatusID !=  0">
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.ticketNo' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('ticketNo')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.email' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('email')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.fullName' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('fullName')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.contact' | translate}}</mat-label>
          <input matInput formControlName="contactNo" required  oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')">
          <mat-error *ngIf="ticketForm.get('contactNo')?.hasError('required')">{{'input.contact' |
            translate}}</mat-error>
        </mat-form-field>
      </nz-form-control>
      <nz-form-control [nzSpan]="24"  *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.contact' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('contactNo')?.value}}</div>
        </div>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="ticketStatusID ==  1">
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.submittedDate' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('submittedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="ticketStatusID != ticketStatusEnum['create']">
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.status' | translate}}</div>
          <div class="labelContent">{{getStatus(ticketStatusID)}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport ">
        <mat-form-field  class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.problemCategory' | translate}}</mat-label>
          <mat-select formControlName="categoryID" required>
            <mat-option *ngFor="let option of problemCategoryList" [value]="option.id"
              (click)="getProblemSubCategory(option.id,true);">
              {{lang == "en" ? option.categoryDescrEng : option.categoryDescrChi}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="ticketForm.get('categoryID')?.hasError('required')">{{'input.problemCategory' | translate
            }}</mat-error>
        </mat-form-field>
      </nz-form-control>
      <nz-form-control [nzSpan]="24"   *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.problemCategory' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('categoryName')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.problemSubCategory' | translate}}</mat-label>
          <mat-select formControlName="subCategoryID" required>
            <mat-option *ngFor="let option of problemSubCategoryList" [value]="option.id" (click)="changeProblemSubCategory();">
              {{lang == "en" ? option.subCategoryDescrEng : option.subCategoryDescrChi}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="ticketForm.get('subCategoryID')?.hasError('required')">{{'input.subCategory' | translate
            }}</mat-error>
        </mat-form-field>
      </nz-form-control>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'] || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.problemSubCategory' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('subCategoryName')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport" >
        <div class="cctoemail" [ngClass]="{'clickEmail':isClickEmail,'mousemoveEmail':isMousemoveEmail}"
          (click)="clickFunction()" (blur)="blurFunction()" (mousemove)="mousemoveFunction()"
          (mouseleave)="mouseleaveFunction()" tabindex="0">
          <nz-select class="h100" nzMode="tags" nzPlaceHolder="{{'ticket.ccToEmial' | translate}}"
            formControlName="emailCC" [nzBorderless]="true">
            <nz-option *ngFor="let option of ccEmailList" [nzLabel]="option" [nzValue]="option"></nz-option>
          </nz-select>
        </div>
      </nz-form-control>
      <nz-form-control [nzSpan]="24" *ngIf="!(ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted'] && !isSupport)" >
        <div class="labelInfo">
          <div class="labelName">{{'ticket.ccToEmial' | translate}}</div>
          <div class="labelContent">{{showEmailList}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <div *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted']  && !isSupport || (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) && !isSupport">
          <div nzTooltipTitle="{{fileName}}" nzTooltipPlacement="topLeft" nz-button nz-tooltip >
          <mat-form-field class="columns">
            <mat-label *ngIf="fileName; else newFile">{{fileName}}</mat-label>
            <ng-template #newFile>
              <mat-label>{{'ticket.attachments' | translate}}</mat-label>
            </ng-template>
            <input matInput disabled>
            <button mat-icon-button matSuffix (click)="fileInput.click()">
              <mat-icon>attach_file</mat-icon>
            </button>
            <input hidden (change)="import($event)" multiple #fileInput type="file" id="file">
          </mat-form-field>
        </div>
        <span>
          <nz-tag  *ngFor="let file of fileList" nzMode="closeable" class="ml20 mb10" (nzOnClose)="deleteFiles(file)">
            <img  nz-image width="80px" height="80px" [nzSrc]="file.showImage" alt="" *ngIf="file.showImage && (file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg') "/>
            <a *ngIf="file.fileMimeType == 'application/pdf'"  (click)="showPdfInfo(file.showImage,file.id,file.originalFileName)"
           > {{file.originalFileName}}</a>
          {{!(file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg ' || file.fileMimeType == 'application/pdf') ? file.originalFileName:""}}</nz-tag>
        </span>
        </div>
        <div *ngIf="(ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) && isSupport || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.attachments' | translate}}</div>
            <div class="labelContent">
              <div class="file">
                <div  *ngFor="let file of fileList" class="mr20 mb10" >
                  <div class="imgInfo"  *ngIf="file.showImage && (file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg') " >
                    <img  class="cursor"  nz-image  width="80px" height="80px" [nzSrc]="file.showImage" alt="" />
                      <span class="cursor downloadText" nz-icon nzType="download" nzTheme="outline" (click)="downloadFile(file.id,file.originalFileName)">{{'button.download' | translate }}</span>
                  </div>
              <a class="cursor" (click)="downloadFile(file.id,file.originalFileName)" *ngIf="!(file.fileMimeType == 'image/png' || file.fileMimeType == 'image/jpeg'|| file.fileMimeType == 'application/pdf')"> {{file.originalFileName}}</a>
              <a class="cursor" (click)="showPdfInfo(file.showImage,file.id,file.originalFileName)" *ngIf="file.fileMimeType == 'application/pdf'"> {{file.originalFileName}}</a></div>
              </div>
            </div>
          </div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['create'] || ticketStatusID == ticketStatusEnum['submitted']  && !isSupport || !isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.description' | translate}} </mat-label>
          <textarea matInput formControlName="detail" required></textarea>
          <mat-error *ngIf="ticketForm.get('detail')?.hasError('required')">{{'input.description' | translate
            }}</mat-error>
        </mat-form-field>
      </nz-form-control>
      <nz-form-control [nzSpan]="24" *ngIf="(ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) && isSupport || ticketStatusID == ticketStatusEnum['closed'] || ticketStatusID == ticketStatusEnum['cancel'] || ticketStatusID == ticketStatusEnum['submitted'] && isSupport">
        <div class="labelInfo">
          <div class="labelInfo">
            <div class="labelName">{{'ticket.description' | translate}}</div>
            <div class="labelContent">{{ticketForm.get('detail')?.value}}</div>
          </div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item  *ngIf="ticketStatusID != ticketStatusEnum['create'] && isSupport">
      <nz-form-control [nzSpan]="24">
        <app-device [info]="deviceInfo">
        </app-device>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
<div class="resolutionInfo pd30" *ngIf="(ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])
&& isSupport || ticketStatusID == ticketStatusEnum['closed']">
  <div class="ticketTitle">
    {{'ticket.resolutionDetails' | translate}}
  </div>
  <form class="mt40" [formGroup]="ticketForm">
    <nz-form-item *ngIf="isSupport">
      <nz-form-control [nzSpan]="6"  *ngIf="ticketForm.get('firstAcceptedUser')?.value">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.firstAcceptBy' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('firstAcceptedUser')?.value}}</div>
        </div>
      </nz-form-control>
      <nz-form-control [nzSpan]="6" *ngIf="ticketForm.get('firstAcceptedUser')?.value">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.firstAcceptDate' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('firstAcceptedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
        </div>
      </nz-form-control>
      <nz-form-control [nzSpan]="6" *ngIf="ticketForm.get('firstAssignedToTeamName')?.value">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.firstAssignedTeam' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('firstAssignedToTeamName')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="isSupport && ticketForm.get('acceptedUser')?.value">
      <nz-form-control [nzSpan]="12">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.acceptBy' | translate}}*</div>
          <div class="labelContent">{{ticketForm.get('acceptedUser')?.value}}</div>
        </div>
      </nz-form-control>
      <nz-form-control [nzSpan]="12">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.acceptDate' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('acceptedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="isSupport">
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.assignedTeam' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('assignedToTeamName')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf=" ticketStatusID == ticketStatusEnum['closed']  && isSupport">
      <nz-form-control [nzSpan]="12">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.closedBy' | translate}}*</div>
          <div class="labelContent">{{ticketForm.get('closedUser')?.value}}</div>
        </div>
      </nz-form-control>
      <nz-form-control [nzSpan]="12">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.closedDate' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('closedDate')?.value | date:'dd/MM/yyyy HH:mm'}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted'] || (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) && isSupport ||  ticketStatusID == ticketStatusEnum['closed']">
      <nz-form-control [nzSpan]="24" *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted'] ||isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.severityLevel' | translate}}</mat-label>
          <mat-select formControlName="severityLevel" required>
            <mat-option [value]="1">
              Level 1
            </mat-option>
            <mat-option [value]="2">
              Level 2
            </mat-option>
            <mat-option [value]="3">
              Level 3
            </mat-option>
            <mat-option [value]="4">
              Level 4
            </mat-option>
          </mat-select>
          <mat-error *ngIf="ticketForm.get('severityLevel')?.hasError('required')">{{'input.severityLevel' | translate
            }}</mat-error>
        </mat-form-field>
      </nz-form-control>
      <nz-form-control [nzSpan]="24" *ngIf="ticketStatusID == ticketStatusEnum['closed']">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.severityLevel' | translate}}</div>
          <div class="labelContent">Level {{ticketForm.get('severityLevel')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted'] || isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])">
      <nz-form-control [nzSpan]="24">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.resolutionType' | translate}}</mat-label>
          <mat-select formControlName="resolutionTypeID" required>
            <mat-option *ngFor="let option of resolutionTypeList" [value]="option.id">
              {{lang == "en" ? option.resolutionTypeDescrEng : option.resolutionTypeDescrChi}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="ticketForm.get('resolutionTypeID')?.hasError('required')">{{'input.resolutionType' |
            translate }}</mat-error>
        </mat-form-field>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted'] || isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])">
      <nz-form-control [nzSpan]="24">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.actualTimeSpent' | translate}}</mat-label>
            <input matInput formControlName="actualTimeSpent" required
              oninput="value=value.replace(/^0|[^0-9]/g, '')"  placeholder="Unit: minutes">
            <mat-error *ngIf="ticketForm.get('actualTimeSpent')?.hasError('required')">{{'input.actualTimeSpent' |
              translate}}</mat-error>
        </mat-form-field>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="!isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) ||  ticketStatusID == ticketStatusEnum['closed']">
      <div class="labelInfo">
        <div class="labelName">{{'ticket.actualTimeSpent' | translate}}</div>
        <div class="labelContent">{{ticketForm.get('actualTimeSpent')?.value}}</div>
      </div>
    </nz-form-item>
    <nz-form-item *ngIf="!isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) ||  ticketStatusID == ticketStatusEnum['closed']">
      <div class="labelInfo">
        <div class="labelName">{{'ticket.resolutionType' | translate}}</div>
        <div class="labelContent">{{ticketForm.get('resolutionTypeName')?.value}}</div>
      </div>
    </nz-form-item>
    <nz-form-item *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted'] || (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])  && isSupport">
      <nz-form-control [nzSpan]="24">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.resolutionComments' | translate}}</mat-label>
          <textarea matInput formControlName="resolutionComments" required></textarea>
          <mat-error *ngIf="ticketForm.get('resolutionComments')?.hasError('required')">{{'input.resolutionComments' |
            translate}}</mat-error>
        </mat-form-field>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="!isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) ||  ticketStatusID == ticketStatusEnum['closed']">
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo">
          <div class="labelName">{{'ticket.resolutionComments' | translate}}</div>
          <div class="labelContent">{{ticketForm.get('resolutionComments')?.value}}</div>
        </div>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
<div class="resolutionInfo pd30 mt20" *ngIf="isSupport && ticketStatusID != 0">
  <div class="ticketTitle">
    {{'ticket.remarkDetails' | translate}}
  </div>
  <form class="mt40" [formGroup]="remarkForm">
    <nz-form-item *ngIf="remarkList.length>0">
      <nz-form-control [nzSpan]="24">
        <div class="labelInfo" >
          <ul>
            <li *ngFor="let item of remarkList">
              <div class="userInfo">
                <div>{{item.userAD}}</div>
                <div>{{item.createdDate | date:'dd/MM/yyyy HH:mm'}}</div>
              </div>
              <div class="remarkInfo" [innerHTML]="item.remark  | linebreaks">
              </div>
          </li>
          </ul>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="!isNotSupportTeam">
      <nz-form-control [nzSpan]="18">
        <mat-form-field class="fullWidth" appearance="fill">
          <mat-label>{{'ticket.remarkComments' | translate}}</mat-label>
          <textarea matInput formControlName="remark"></textarea>
        </mat-form-field>
      </nz-form-control>
      <nz-form-control [nzSpan]="6">
        <button mat-raised-button color="primary" [disabled]="!remarkForm.get('remark')?.value" class="ml20" (click)="addRemark()">{{'button.remark' | translate }}</button>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
<div class="buttonInfo mb20" *ngIf="!isShowLoading && !isNotSupportTeam">
  <button mat-raised-button color="primary"
    *ngIf="ticketStatusID == ticketStatusEnum['create'] || !isSupport && ticketStatusID == ticketStatusEnum['submitted'] || !isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])"
    [disabled]="!ticketForm.valid || isLoading" class="mr20" (click)="saveForm()">{{ (ticketStatusID == ticketStatusEnum['create'] ?
    'button.submit' : 'button.save' ) | translate}}</button>
  <button mat-raised-button color="primary" *ngIf=" !isSupport && (ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign']) " (click)="cancelForm()"
   >{{ 'button.cancelTicket' | translate}}</button>
  <button mat-raised-button color="primary" *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['reassign'])" class="mr20"
    [disabled]="isLoading || ticketForm.get('subCategoryID')?.value == ''" (click)="acceptForm()">{{ 'button.accept' | translate}}</button>
  <button mat-raised-button color="primary" *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])" class="mr20"
    [disabled]="isLoading" [disabled]="!ticketForm.valid || isLoading" (click)="saveAcceptForm()">{{ 'button.save' |
    translate}}</button>
    <button mat-raised-button color="primary" [disabled]="isLoading || ticketForm.get('subCategoryID')?.value == ''" *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['submitted'] || ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])" (click)="reassignTeam()" class="mr20">{{
      'button.reassign' | translate}}</button>
  <button mat-raised-button color="primary" *ngIf="isSupport && (ticketStatusID == ticketStatusEnum['inProgress'] || ticketStatusID == ticketStatusEnum['reassign'])"
    [disabled]="!ticketForm.valid || isLoading || ticketForm.get('resolutionTypeID')?.value == null"
    (click)="closeTicketForm()">{{ 'button.closeTicket' | translate}}</button>
  <button mat-raised-button color="primary" *ngIf="isSupport && ticketStatusID == ticketStatusEnum['submitted']"
    [disabled]="!ticketForm.valid || isLoading || ticketForm.get('resolutionTypeID')?.value == null"
    (click)="closeTicketForm()">{{ 'button.acceptAndClose' | translate}}</button>
</div>
<nz-modal [(nzVisible)]="isSubmitVisible" (nzOnCancel)="handleBack()" [nzClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin">{{ (!isSaveTicket ? 'popup.createTicket' : 'popup.saveTicket') | translate }}
    </p>
    <p class="smInfo textalgin">{{'popup.ticketNo' | translate }} - {{ticketNo}}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" (click)="handleBack()" class="mr20 colorBack">{{'button.backToTicket' |
      translate }}</button>
    <button mat-raised-button color="primary" (click)="handleOk()">{{'button.GoToInquiryList' | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isCancelVisible" (nzOnCancel)="handleBack()" [nzClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" *ngIf="!isClosed">{{'popup.questionToConfirmClose1' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="!isClosed">{{'popup.questionToConfirmClose3' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isClosed">{{'popup.ticketClose' | translate }}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" *ngIf="!isClosed" (click)="backToTicket()"
      class="mr20 colorBack">{{'button.backToTicket' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="!isClosed" [disabled]="isButtonLoading"
      (click)="handleCancelOk()">{{'button.confirm' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isClosed" (click)="closeTicket()">{{'button.GoToInquiryList' |
      translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowAccept" (nzOnCancel)="isShowAccept = false" [nzClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin">{{'popup.acceptedTicket' | translate}}</p>
    <p class="smInfo textalgin">{{'popup.acceptedSentense' | translate}}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" (click)="backToTicket();" class="mr20 colorBack">{{'button.backToTicket' |
      translate }}</button>
    <button mat-raised-button color="primary" (click)="closeTicket()">{{'button.GoToInquiryList' | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isReassignTeam" (nzOnCancel)="isReassignTeam = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p *ngIf="!isReassignTicket" class="smInfo textalgin">{{'popup.ticketNo' | translate }} - {{ticketNo}}</p>
    <p *ngIf="!isReassignTicket" class="messageInfo textalgin">{{'popup.selectReassign' | translate }}</p>
    <mat-form-field class="fullWidth" appearance="fill" *ngIf="!isReassignTicket">
      <mat-label>{{'ticket.assignedTeam' | translate }} </mat-label>
      <mat-select [(ngModel)]="assignedToTeamID">
        <mat-option *ngFor="let option of assignedToTeamList" [value]="option.id">
          {{option.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <p class="messageInfo textalgin" *ngIf="isReassignTicket">{{ 'popup.reassignedTo' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isReassignTicket">{{assignedToTeamName}}</p>
    <p class="smInfo textalgin" *ngIf="isReassignTicket">{{'popup.ticketNo' | translate }}- {{ticketNo}} </p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary"  *ngIf="!isReassignTicket" (click)="backToTicket()" class="mr20 colorBack">{{'button.backToTicket' |
      translate }}</button>
    <button mat-raised-button color="primary"  *ngIf="!isReassignTicket" [disabled]="isButtonLoading" (click)="reassign()">{{'button.reassign' |
      translate }}</button>
    <button mat-raised-button color="primary"  *ngIf="isReassignTicket"  (click)="closeTicket()">{{'button.GoToInquiryList' |
      translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isClosedVisible" (nzOnCancel)="isClosedVisible = false" [nzClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" *ngIf="!isClosedTicket">{{'popup.questionToConfirmClose1' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="!isClosedTicket">{{'popup.questionToConfirmClose2' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isClosedTicket">{{'popup.ConfirmClose' | translate }}</p>
    <p class="smInfo textalgin" *ngIf="isClosedTicket">{{'popup.ticketNo' | translate }}- {{ticketNo}} </p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" *ngIf="!isClosedTicket" (click)="backToTicket()"
      class="mr20 colorBack">{{'button.backToTicket' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="!isClosedTicket" (click)="handleClosedOk()"
      [disabled]="isButtonLoading">{{'button.confirm' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isClosedTicket" (click)="closeTicket()">{{'button.GoToInquiryList'
      | translate }}</button>
  </div>
</nz-modal>
<nz-modal [(nzVisible)]="isShowChangeSubCategoryReassignLog" (nzOnCancel)="isShowChangeSubCategoryReassignLog = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" *ngIf="!isShowReassignTicket">{{'popup.reassignedMsg1' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="!isShowReassignTicket">{{'popup.reassignedMsg2' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isShowReassignTicket">{{ 'popup.reassignedTo' | translate }}</p>
    <p class="messageInfo textalgin" *ngIf="isShowReassignTicket">{{assignedToTeamNameChangeSubCategory}}</p>
    <p class="smInfo textalgin" *ngIf="isShowReassignTicket">{{'popup.ticketNo' | translate }}- {{ticketNo}} </p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" *ngIf="!isShowReassignTicket" (click)="backToTicket()"
      class="mr20 colorBack">{{'button.backToTicket' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="!isShowReassignTicket" (click)="changeSubCategoryReassignOK();"
      [disabled]="isButtonLoading">{{'button.confirm' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isShowReassignTicket" (click)="closeTicket()">{{'button.GoToInquiryList'
      | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowPdf" nzWidth="1200px" (nzOnCancel)="isShowPdf = false" [nzClosable]="false">
  <div *nzModalContent>
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
      style="width: 100%;height: 800px;"></pdf-viewer>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary"  class="mr20" (click)="isShowPdf = false">{{'button.back' | translate }}</button>
    <button mat-raised-button color="primary" *ngIf="isSupport"  (click)="downloadFile(pdfId,pdfName)">{{'button.download' | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isBackConfirm"  [nzClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin">{{'popup.leave' | translate}}</p>
    <p class="smInfo textalgin">{{'popup.leaveSmall' | translate}}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary" (click)="closeTicket();" class="mr20 colorBack">{{'button.leave' |
      translate }}</button>
    <button mat-raised-button color="primary" (click)="backToTicket();">{{'button.stay' | translate }}</button>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isShowAcceptSubCategory" (nzOnCancel)="isShowAcceptSubCategory = false" [nzClosable]="false" [nzMaskClosable]="false">
  <div *nzModalContent>
    <p class="messageInfo textalgin" >{{'popup.acceptMsg' | translate }}</p>
  </div>
  <div *nzModalFooter class="textalgin">
    <button mat-raised-button color="primary"  (click)="backToTicket()"
      class="mr20 colorBack">{{'button.backToTicket' | translate }}</button>
    <button mat-raised-button color="primary"  (click)="acceptFormChangeSubCategory()"
      [disabled]="isButtonLoading">{{'button.confirm' | translate }}</button>
  </div>
</nz-modal>
